import styled from 'styled-components';
import { visuallyHidden as visuallyHiddenMixin } from 'styles/mixins';
var VisuallyHidden = styled.span.withConfig({
  displayName: "VisuallyHidden",
  componentId: "sc-7fzli2-0"
})(["", ""], visuallyHiddenMixin);
export default VisuallyHidden;